import PayzenBaseClass from './PayzenBaseClass';
import {inject, observer} from 'mobx-react';

class PayzenBase extends PayzenBaseClass {}

export default inject('depositsStore')(observer(PayzenBase));
